import { Modal, ModalContent } from '@frontend/legacy-components';

import Body from './Body';
import Footer from './Footer';
import Header from './Header';

const HelpModeModal = ({
  isClosable,
  isOpen,
  video,
  onBack,
  onClose,
  onGoToDrawer,
}) => {
  if (!video) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      {/* TODO: Refactor Header, Body, Footer to work with ModalHeader, ModalBody, ModalFooter */}
      <ModalContent overflow="hidden">
        <Header
          title={video.title}
          subtitle={video.subtitle}
          onClose={onClose}
        />
        {video && <Body video={video} />}
        <Footer
          video={video}
          isClosable={isClosable}
          onBack={onBack}
          onClose={onClose}
          onGoToDrawer={onGoToDrawer}
        />
      </ModalContent>
    </Modal>
  );
};

export default HelpModeModal;
